let cardWidthInit = () => {
  const xl = 1200
  let cardGetElement = document.querySelector('.js-card-width-get')
  if (xl <= window.innerWidth && cardGetElement) {
    let resize = () => {
      let cardWidthGetter = cardGetElement.getBoundingClientRect()
      let cardWidth = cardWidthGetter.width
      let cardPositionX = cardWidthGetter.x
      let cardWidthSetters = document.querySelectorAll('.js-card-width-set')
      cardWidthSetters.forEach(el => {
        el.style.width = `${cardWidth + cardPositionX}px`
      })
    }
    resize()
    window.addEventListener("resize", () => {
      if (xl <= window.innerWidth) {
        resize()
      }
    })
  }
}
export default cardWidthInit



// WEBPACK FOOTER //
// ./src/js/scripts/cardWidth.js